function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import actions from './actions';
export var setCurrentPage = payload => /*#__PURE__*/function () {
  var _thunk = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setCurrentPage.receive(payload));
  });
  function thunk(_x) {
    return _thunk.apply(this, arguments);
  }
  return thunk;
}();
export var setPrevPageTotal = payload => /*#__PURE__*/function () {
  var _thunk2 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setPrevPageTotal.receive(payload));
  });
  function thunk(_x2) {
    return _thunk2.apply(this, arguments);
  }
  return thunk;
}();